const TestimonialSection = () => {
  return (
    <section className="relative py-24 bg-gradient-to-br from-slate-900 to-slate-800 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-4">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/03b7eda50757b81420972dba047a1614.jpg"
                alt="Client Testimonial"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl border-4 border-cyan-400/50"
              />
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="relative">
              <i className="ri-double-quotes-l text-8xl text-cyan-400 opacity-50 absolute -top-8 -left-4"></i>
              <div className="relative z-10 pl-8">
                <p className="text-2xl lg:text-3xl text-white leading-relaxed mb-8 font-light">
                  Working with this IT services team has been transformational for our business. Their cloud migration expertise reduced our infrastructure costs by 40% while improving performance. The cybersecurity measures they implemented give us complete peace of mind.
                </p>
                <div className="space-y-2">
                  <h4 className="text-xl font-bold text-white">Sarah Mitchell</h4>
                  <p className="text-base text-gray-400">CTO, TechVentures Inc.</p>
                </div>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/services')}
                  className="mt-8 px-8 py-3 bg-pink-500 text-slate-900 font-semibold rounded-full hover:bg-pink-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  View Case Study
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute top-12 left-12 opacity-20">
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M50 100 Q 75 50, 100 100 T 150 100" stroke="currentColor" strokeWidth="2" className="text-cyan-400"/>
          <circle cx="50" cy="100" r="4" fill="currentColor" className="text-cyan-400"/>
          <circle cx="100" cy="100" r="4" fill="currentColor" className="text-cyan-400"/>
          <circle cx="150" cy="100" r="4" fill="currentColor" className="text-cyan-400"/>
        </svg>
      </div>
    </section>
  );
};

export default TestimonialSection;